module.exports = __webpack_public_path__ + "static/media/question-button-press-c.074dc605.png";